exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customFloat[data-v-9e26ecdc]{position:fixed;width:-moz-fit-content;width:fit-content;height:-moz-fit-content;height:fit-content;bottom:30px;right:30px}.customSize[data-v-9e26ecdc]{width:70px;height:70px}.customOptionSize[data-v-9e26ecdc]{width:50px;height:50px}.zoomInEffect[data-v-9e26ecdc]{opacity:1;animation:zoominanimation-data-v-9e26ecdc .5s ease-in-out}@keyframes zoominanimation-data-v-9e26ecdc{0%{opacity:0;scale:0}to{opacity:1;scale:1}}", ""]);

// exports
